import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { 
  Home, 
  Upload, 
  FileText, 
  ClipboardList, 
  LogOut, 
  User,
  Menu,
  X
} from 'lucide-react';
import { useState } from 'react';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { user, logout } = useAuth();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navigation = [
    { name: 'Главная', href: '/', icon: Home },
    { name: 'Загрузить файл', href: '/upload', icon: Upload },
    { name: 'Стенограммы', href: '/transcriptions', icon: FileText },
    { name: 'Протоколы', href: '/protocols', icon: ClipboardList },
  ];

  const isActive = (href: string) => {
    return location.pathname === href;
  };

  return (
    <div className="min-h-screen bg-secondary-50">
      {/* Мобильное меню */}
      <div className="lg:hidden">
        <div className="flex items-center justify-between p-4 bg-white border-b border-secondary-200">
          <h1 className="text-xl font-semibold text-secondary-900">РЕШИЛИ:</h1>
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="p-2 rounded-lg text-secondary-600 hover:bg-secondary-100"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
        
        {isMobileMenuOpen && (
          <div className="bg-white border-b border-secondary-200 shadow-lg">
            <nav className="px-4 py-2 space-y-1">
              {navigation.map((item) => {
                const Icon = item.icon;
                return (
                  <Link
                    key={item.name}
                    to={item.href}
                    onClick={() => setIsMobileMenuOpen(false)}
                    className={`flex items-center px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                      isActive(item.href)
                        ? 'bg-primary-100 text-primary-700'
                        : 'text-secondary-700 hover:bg-secondary-100'
                    }`}
                  >
                    <Icon size={20} className="mr-3" />
                    {item.name}
                  </Link>
                );
              })}
            </nav>
            <div className="px-4 py-3 border-t border-secondary-200">
              <div className="flex items-center mb-3">
                <User size={20} className="mr-3 text-secondary-600" />
                <span className="text-sm font-medium text-secondary-900">{user?.email}</span>
              </div>
              <button
                onClick={logout}
                className="flex items-center w-full px-3 py-2 text-sm font-medium text-red-600 hover:bg-red-50 rounded-lg transition-colors"
              >
                <LogOut size={20} className="mr-3" />
                Выйти
              </button>
            </div>
          </div>
        )}
      </div>

      {/* Десктопное меню */}
      <div className="hidden lg:flex lg:w-64 lg:flex-col lg:fixed lg:inset-y-0">
        <div className="flex flex-col flex-grow bg-white border-r border-secondary-200">
          <div className="flex items-center flex-shrink-0 px-6 py-4">
            <h1 className="text-xl font-semibold text-secondary-900">РЕШИЛИ:</h1>
          </div>
          <div className="flex flex-col flex-grow">
            <nav className="flex-1 px-4 py-4 space-y-2">
              {navigation.map((item) => {
                const Icon = item.icon;
                return (
                  <Link
                    key={item.name}
                    to={item.href}
                    className={`flex items-center px-3 py-2 rounded-lg text-sm font-medium transition-colors ${
                      isActive(item.href)
                        ? 'bg-primary-100 text-primary-700'
                        : 'text-secondary-700 hover:bg-secondary-100'
                    }`}
                  >
                    <Icon size={20} className="mr-3" />
                    {item.name}
                  </Link>
                );
              })}
            </nav>
            <div className="flex-shrink-0 px-4 py-4 border-t border-secondary-200">
              <div className="flex items-center mb-3">
                <User size={20} className="mr-3 text-secondary-600" />
                <span className="text-sm font-medium text-secondary-900">{user?.email}</span>
              </div>
              <button
                onClick={logout}
                className="flex items-center w-full px-3 py-2 text-sm font-medium text-red-600 hover:bg-red-50 rounded-lg transition-colors"
              >
                <LogOut size={20} className="mr-3" />
                Выйти
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Основной контент */}
      <div className="lg:pl-64">
        <main className="py-6">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};
